import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/Login/Login.vue"),
    meta: { isPublic: true, title: "Inicio de Sesión" }
  },
  {
    path: "/recibos",
    name: "Recibos",
    component: () => import("@/views/Recibos.vue"),
    meta: { title: "SETUTSA Socios" }
  },
  {
    path: "/unidades",
    name: "Unidades",
    component: () => import("@/views/Unidades.vue"),
    meta: { title: "SETUTSA Socios" }
  },
  {
    path: "/cobranza",
    name: "Cobranza",
    component: () => import("@/views/Cobranza.vue"),
    meta: { title: "SETUTSA Socios" }
  },
  {
    path: "/socio",
    name: "Socio",
    component: () => import("@/views/Socios.vue"),
    meta: { title: "SETUTSA Socios" }
  },
  {
    path: "/recibos-cobranza",
    name: "RecibosCobranza",
    component: () => import("@/views/RecibosCobranza.vue"),
    meta: { title: "SETUTSA Socios" }
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const { title, isPublic } = to.meta;
  const { auth } = store.getters;
  document.title = title;
  if (to.path == "/" && auth) {
    next("unidades");
  } else if (auth || isPublic) {
    next();
  } else {
    next("/");
  }
});

export default router;
